export default __webpack_public_path__ + "media/images/react_icons/property/sky_balcony-8cb05208c95cbb1c7c87c5a2e891cff3.svg";